if (!customElements.get('yotpo-points-balance')) {

  class YotpoProductPoints extends HTMLElement {
      
    constructor() {
      super();
      this.points = 0;
      this.lifetimePoints = 0;
      this.pointsElements = this.querySelectorAll('[data-points]');
      this.lifetimePointsElement = this.querySelector('[data-lifetime-points]');
      this.viewRewardsHistoryModal = this.querySelector('.rewards-history-modal .yotpo-grid');

      document.addEventListener("swell:setup", (event) => {
        this.initializeSwell();
      })

      this.checkSwellReady();
    }

    checkSwellReady() {

      this.loaderPointsBalance('true');

      const checkInterval = setInterval(() => {

        if (typeof swellAPI !== 'undefined' && swellAPI.getCustomerDetails) {
          clearInterval(checkInterval);

          const balanceInterval = setInterval(async () => {
            try {
              const customerDetails = await swellAPI.getCustomerDetails();
              if (customerDetails && customerDetails.pointsBalance > 0) {
                clearInterval(balanceInterval);
                this.initializeSwell();
              }
            } catch (err) {
              console.error('Error fetching customer details:', err);
            }
          }, 200);

          setTimeout(() => clearInterval(balanceInterval), 3000);
        }
      }, 200);
    
      setTimeout(() => clearInterval(checkInterval), 3000);
    }
    

    initializeSwell() {
      this.displayPointsBalance();
      //this.displayPointsEarned();
      this.viewRewardsHistory();
    }

    loaderPointsBalance(state) {
      this.pointsElements.forEach(element => {
        element.innerHTML = '';
        element.setAttribute('data-loading', state);
      })
    }

    displayPointsBalance() {
      this.loaderPointsBalance('false');
      this.points = swellAPI.getCustomerDetails().pointsBalance ?? 0;
      
      this.pointsElements.forEach(element => {
        if (this.points !== 0) {
          if (element.classList.contains('hero')) {
            element.innerHTML = this.points;
          } else {
            element.innerHTML = this.points + ' pts';
          }
        } else {
          element.innerHTML = 'LOYALTY'
          element.classList.remove('hidden');
        }
      })
    }

    displayPointsEarned() {
      this.lifetimePoints = swellAPI.getCustomerDetails().pointsEarned ?? 0;

      if (this.lifetimePointsElement) {
        this.lifetimePointsElement.innerHTML = this.lifetimePoints;
      }
    }

    viewRewardsHistory() {
      const actionHistoryItems = swellAPI.getCustomerDetails().actionHistoryItems;
      const rewardsHistoryModal = this.querySelector('.rewards-history-modal .yotpo-grid');

      if (!rewardsHistoryModal) return;
    
      // Clear any existing table rows
      rewardsHistoryModal.innerHTML = '';
    
      // Create a table row for each action history item
      actionHistoryItems.forEach((item) => {
        const mediaQuery = window.matchMedia("(min-width: 750px)");
        if (mediaQuery.matches) {
          const rowGroup = document.createElement('div');
          rowGroup.role = 'rowgroup';
          rowGroup.className = 'yotpo-grid-row';
          
          const tableRow = document.createElement('div');
          tableRow.role = 'row';
          tableRow.className = 'yotpo-row-display border-style-rectangular yotpo-border-style';
      
          const firstRowDesktop = document.createElement('div');
          firstRowDesktop.className = 'first-row-desktop';
      
          const dateColumn = document.createElement('div');
          dateColumn.className = 'yotpo-customized-text row-date-column yotpo-row-desktop-text';
          dateColumn.role = 'gridcell';
          dateColumn.ariaColindex = '2';
          dateColumn.ariaColindextext = 'Date';
          dateColumn.scope = 'col';
          dateColumn.tabindex = '0';
      
          const dateInnerText = document.createElement('div');
          dateInnerText.className = 'yotpo-inner-text';
          dateInnerText.textContent = item.date.replace(/-/g, '/');
          dateColumn.appendChild(dateInnerText);
      
          const actionColumn = document.createElement('div');
          actionColumn.className = 'yotpo-customized-text row-action-column yotpo-row-desktop-text';
          actionColumn.role = 'gridcell';
          actionColumn.ariaColindex = '3';
          actionColumn.ariaColindextext = 'Action';
          actionColumn.scope = 'col';
          actionColumn.tabindex = '0';
      
          const actionInnerText = document.createElement('div');
          actionInnerText.className = 'yotpo-inner-text';
          actionInnerText.textContent = item.action;
          actionColumn.appendChild(actionInnerText);
      
          firstRowDesktop.appendChild(dateColumn);
          firstRowDesktop.appendChild(actionColumn);
      
          const secondRowDesktop = document.createElement('div');
          secondRowDesktop.className = 'second-row-desktop';
      
          const pointsColumn = document.createElement('div');
          pointsColumn.className = 'row-points-column-wrapper';
      
          const pointsInnerColumn = document.createElement('div');
          pointsInnerColumn.className = 'yotpo-customized-text row-points-column yotpo-row-desktop-text';
          pointsInnerColumn.role = 'gridcell';
          pointsInnerColumn.ariaColindex = '4';
          pointsInnerColumn.ariaColindextext = 'Points';
          pointsInnerColumn.scope = 'col';
          pointsInnerColumn.tabindex = '0';
      
          const pointsInnerText = document.createElement('div');
          pointsInnerText.className = 'yotpo-inner-text';
          pointsInnerText.textContent = item.points;
          pointsInnerColumn.appendChild(pointsInnerText);
      
          pointsColumn.appendChild(pointsInnerColumn);
      

          const statusColumn = document.createElement('div');
          statusColumn.className = 'yotpo-customized-text row-status-column yotpo-row-desktop-text';
          statusColumn.role = 'gridcell';
          statusColumn.ariaColindex = '4';
          statusColumn.ariaColindextext = 'Status';
          statusColumn.scope = 'col';
          statusColumn.tabindex = '0';

          const statusInnerText = document.createElement('div');
          statusInnerText.className = 'yotpo-inner-text';
          statusInnerText.textContent = item.status !== undefined ? item.status : 'Approved';

          statusColumn.appendChild(statusInnerText);

          secondRowDesktop.appendChild(pointsColumn);
          secondRowDesktop.appendChild(statusColumn);
      
          tableRow.appendChild(firstRowDesktop);
          tableRow.appendChild(secondRowDesktop);

          rowGroup.appendChild(tableRow);
          rewardsHistoryModal.appendChild(rowGroup);
        } else {
          const mobileRowGroup = document.createElement('div');
          mobileRowGroup.role = 'rowgroup';
          mobileRowGroup.className = 'yotpo-grid-row';

          const mobileTableRow = document.createElement('div');
          mobileTableRow.role = 'row';
          mobileTableRow.className = 'yotpo-row-display border-style-rectangular yotpo-is-mobile yotpo-border-style';
        
          const firstRowMobile = document.createElement('div');
          firstRowMobile.className = 'first-row-mobile';

          const mobileDateColumn = document.createElement('div');
          mobileDateColumn.className = 'yotpo-customized-text row-date-column yotpo-row-mobile-text';
          mobileDateColumn.role = 'gridcell';
          mobileDateColumn.ariaColindex = '2';
          mobileDateColumn.ariaColindextext = 'Date';
          mobileDateColumn.scope = 'col';
          mobileDateColumn.tabindex = '0';

          const mobileDateInnerText = document.createElement('div');
          mobileDateInnerText.className = 'yotpo-inner-text';
          mobileDateInnerText.textContent = item.date.replace(/-/g, '/');

          mobileDateColumn.appendChild(mobileDateInnerText);
          firstRowMobile.appendChild(mobileDateColumn);

          const mobileActionColumn = document.createElement('div');
          mobileActionColumn.className = 'yotpo-customized-text row-action-column yotpo-row-mobile-text';
          mobileActionColumn.role = 'gridcell';
          mobileActionColumn.ariaColindex = '3';
          mobileActionColumn.ariaColindextext = 'Action';
          mobileActionColumn.scope = 'col';
          mobileActionColumn.tabindex = '0';

          const mobileActionInnerText = document.createElement('div');
          mobileActionInnerText.className = 'yotpo-inner-text';
          mobileActionInnerText.textContent = item.action;

          mobileActionColumn.appendChild(mobileActionInnerText);
          firstRowMobile.appendChild(mobileActionColumn);

          const secondRowMobile = document.createElement('div');
          secondRowMobile.className = 'second-row-mobile';

          const mobilePointsColumn = document.createElement('div');
          mobilePointsColumn.className = 'row-points-column-wrapper';

          const mobilePointsInnerColumn = document.createElement('div');
          mobilePointsInnerColumn.className = 'yotpo-customized-text row-points-column yotpo-row-mobile-text';
          mobilePointsInnerColumn.role = 'gridcell';
          mobilePointsInnerColumn.ariaColindex = '4';
          mobilePointsInnerColumn.ariaColindextext = 'Points';
          mobilePointsInnerColumn.scope = 'col';
          mobilePointsInnerColumn.tabindex = '0';

          const mobilePointsInnerText = document.createElement('div');
          mobilePointsInnerText.className = 'yotpo-inner-text';
          mobilePointsInnerText.textContent = item.points + ' Points';

          mobilePointsInnerColumn.appendChild(mobilePointsInnerText);
          mobilePointsColumn.appendChild(mobilePointsInnerColumn);

          secondRowMobile.appendChild(mobilePointsColumn);

          const mobileStatusColumn = document.createElement('div');
          mobileStatusColumn.className = 'row-status-column';

          const mobileStatusInnerText = document.createElement('div');
          mobileStatusInnerText.className = 'yotpo-customized-text yotpo-row-mobile-text';
          mobileStatusInnerText.role = 'gridcell';
          mobileStatusInnerText.ariaColindex = '6';
          mobileStatusInnerText.ariaColindextext = 'Status';
          mobileStatusInnerText.scope = 'col';
          mobileStatusInnerText.tabindex = '0';

          const mobileStatusText = document.createElement('div');
          mobileStatusText.className = 'yotpo-inner-text';
          mobileStatusText.textContent = item.status !== undefined ? item.status : 'Approved';

          mobileStatusInnerText.appendChild(mobileStatusText);
          mobileStatusColumn.appendChild(mobileStatusInnerText);

          secondRowMobile.appendChild(mobileStatusColumn);

          mobileTableRow.appendChild(firstRowMobile);
          mobileTableRow.appendChild(secondRowMobile);
          mobileRowGroup.appendChild(mobileTableRow);

          rewardsHistoryModal.appendChild(mobileRowGroup);
        }
        
      });
    }

  }
  
  customElements.define('yotpo-points-balance', YotpoProductPoints);
  
}